import { connect } from 'react-redux';
import asContentPage from 'components/hoc/asContentPage';
import { forceMiniPlayerState } from 'actions/player-actions';
import { setHidden } from 'actions/search-actions';
import withContentfulData from 'components/hoc/withContentfulData';

import FaqContactPage from './FaqContactPage';

const FaqContactPageContainer = connect(null, {
  forceMiniPlayerState,
  setSearchHidden: setHidden,
})(FaqContactPage);
export default asContentPage('faqContact', withContentfulData(FaqContactPageContainer));
